module.exports = __webpack_public_path__ + "img/sv2.f83bfb31.png";